// removed by extract-text-webpack-plugin
module.exports = {"services-card-footer":"ServicesCardFooter__services-card-footer___1UQIM","services-card-footer-links":"ServicesCardFooter__services-card-footer-links___3ur8V"};